import { useGoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode"; // Use named import for jwtDecode in v4.0.0+
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "ui/Notification";
import { addGoogleCalendarAccount, fetchGoogleCalendarAccounts, fetchGoogleCalendarAuths } from "../store/google-calendar"; // Import actions and selectors
export const useGoogleCalendarAuth = () => {
  const [googleAccounts, setGoogleAccounts] = useState([])
  const [, setError] = useState(null)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  // Access googleAuths from Redux state
  const { googleAuths } = useSelector((state) => state.googleCalendar)

  // Fetch googleAuths on initialization
  useEffect(() => {
    dispatch(fetchGoogleCalendarAuths())
  }, [dispatch])

  const onLoginSuccess = async (codeResponse) => {
    const url = window.location.origin
    try {
      const tokenExchangeResponse = await fetch("https://oauth2.googleapis.com/token", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          code: codeResponse.code,
          client_id: googleAuths.client_id,
          client_secret: googleAuths.client_secret,
          redirect_uri: url,
          grant_type: "authorization_code"
        })
      })
      const tokenData = await tokenExchangeResponse.json()
      if (tokenData.access_token && tokenData.id_token) {
        const { email } = jwtDecode(tokenData.id_token) // Decode the JWT token
        onAddGoogleAccount({ email, ...tokenData })
      } else {
        throw new Error(t("google_calendar.access_error"))
      }
    } catch (error) {
      console.error("Authentication error:", error)
      setError(t("google_calendar.auth_error"))
    }
  }

  const onLoginError = (error) => {
    console.error("Login failed:", error)
    if (error.error === "popup_closed_by_user") {
      setError(t("google_calendar.pop_up_message"))
    } else {
      setError(t("google_calendar.sign_in_error"))
    }
  }

  const login = useGoogleLogin({
    flow: "auth-code",
    onSuccess: onLoginSuccess,
    onError: onLoginError,
    ux_mode: "popup",
    redirect_uri: window.location.origin,
    scope: "https://www.googleapis.com/auth/calendar"
  })

  const onAddGoogleAccount = (values) => {
    const google_calendar = {
      ...values,
      category: "activity",
      type: "web"
    }

    dispatch(addGoogleCalendarAccount(google_calendar)).then(() => {
      notification.success({
        message: t("google_calendar.success_message")
      })
      dispatch(fetchGoogleCalendarAccounts())
    })
  }

  return { login, googleAccounts, setGoogleAccounts, googleAuths }
}
